import React from "react";
import { Box, Text } from "@showitinc/showit-wc";
import styles from "./HTMLEditorModal.module.css";

const ValidationErrorMessage = ({ validationErrors }) => {
  if (validationErrors.length === 0) {
    return null;
  }

  return (
    <Box
      position="absolute"
      bottom="3.75rem"
      left="1rem"
      bg="white"
      boxShadow="lg"
      p="3"
      borderRadius=".25rem"
      maxWidth="25rem"
      zIndex="1000"
    >
      <Text className={styles.error} variant="body-2">
        Your code has errors that may cause issues:
      </Text>
      <Box as="ul" pl="4" mb="0">
        {validationErrors.slice(0, 3).map((marker, index) => (
          <Box as="li" key={index} mb="1">
            <Text className={styles.error} variant="body-2">
              Line {marker.startLineNumber}: {marker.message}
            </Text>
          </Box>
        ))}
        {validationErrors.length > 3 && (
          <Box as="li">
            <Text className={styles.error} variant="body-2">
              ...and {validationErrors.length - 3} more error(s)
            </Text>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ValidationErrorMessage;
